// extracted by mini-css-extract-plugin
export var displayNone = "_rb-6";
export var imgContainer = "_rb-2";
export var overflowHidden = "_rb-3";
export var productInfoCardButtonContainer = "_rb-5";
export var productTitleText = "_rb-4";
export var rightArrow = "_rb-1";
export var rightArrowContainer = "_rb-0";